import { classNames } from '@/core'
import { IconCheck } from './icon-check'
import styles from './style.module.less'

export const Checkbox = ({
  name,
  value,
  label,
  long = false,
  noBorder = false,
  ...props
}) => (
  <div
    className={classNames(
      styles.checkbox,
      long && styles.long,
      noBorder && styles.noBorder
    )}
  >
    <input
      type="checkbox"
      id={`checkbox-${name}-${value}`}
      name={name}
      value={value}
      {...props}
    />
    <label for={`checkbox-${name}-${value}`}>
      <span className={styles.check}>
        <IconCheck />
      </span>
      {label || name}
    </label>
  </div>
)
